import classes from "./login.module.scss";

import React from "react";

import { ImageLazy } from "@app/components";

import { LoginContent, LoginFooter, LoginHeader } from "./components";
import { PageLoginProvider } from "./contexts";

export const PageLogin = () => {
  document.title = "Login | HIVERY Curate";

  const images = [
    {
      src: "https://res.cloudinary.com/hivery/image/upload/v1587523429/hivery-assets/LoginPage_Graphic_FlatPurple.png",
      alt: "hivery background",
    },
    {
      src: "https://res.cloudinary.com/hivery/image/upload/v1587530567/hivery-assets/HIVERY_Circle-2_RGB_Cyan.png",
      alt: "animation bubble",
      classes: classes["img-circuits"],
    },
  ];

  return (
    <PageLoginProvider>
      <div className={classes["container"]}>
        <div className={classes["login-container"]}>
          <div className={classes["login-layout"]}>
            <LoginHeader />
            <LoginContent />
            <LoginFooter />
          </div>
        </div>
        <div className={classes["login-image-container"]}>
          <div className={classes["login-page-image"]}>
            <ImageLazy sources={images} />
          </div>
        </div>
      </div>
    </PageLoginProvider>
  );
};
